var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",attrs:{"id":"header"}},[_c('iframe',{staticStyle:{"overflow":"hidden"},attrs:{"name":"VeeamProduct","src":"https://wcs-veeamproducts-pwa.swcontentsyndication.com/VeeamProduct-Homepage-EN","scrolling":"yes","title":"veeamproducts","width":"100%","height":"100%","frameborder":"0"}})])
}]

export { render, staticRenderFns }